// extracted by mini-css-extract-plugin
export var clickable = "PromotionBannerContainer_clickable__PL7FE";
export var container = "PromotionBannerContainer_container__L1hLs";